import { render, staticRenderFns } from "./ErroAnexoDlg.vue?vue&type=template&id=2be7a3d0"
import script from "./ErroAnexoDlg.vue?vue&type=script&lang=js"
export * from "./ErroAnexoDlg.vue?vue&type=script&lang=js"
import style0 from "./ErroAnexoDlg.vue?vue&type=style&index=0&id=2be7a3d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports